import React from 'react';
import { Helmet } from 'react-helmet';

import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';
import AirtableImage from '../core/AirtableImage';

interface Props {

}

export default class Head extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const general = data.generalParameters;
    const page = data.pageParameters;

    const company = general.getValue('CompanyName');
    const title = page.getValueOrNull('TitleOverride') || `${company} | ${page.getValue('Title')}`;
    const metaTitle = page.getValueOrNull('MetaTitle') || title;
    const facebook = general.getValueOrNull('Facebook');
    const twitter = general.getValueOrNull('Twitter');
    const twitterHandle = twitter ? twitter.replace(/.*\//, '@') : null;
    const fav = general.getImage('Favicon');

    const isProd = process.env.NODE_ENV === 'production';

    const description = page.getContentOrNull('Description');

    const gaTracking = general.getValueOrNull('GoogleAnalyticsTrackingId');

    const noIndex = page.getValueAsBoolOrNull('NoIndex');

    // making a decent amount of assumption about URL shape here, but that's
    // fine for now.
    const url = general.getValue('Url');
    const cslug = page.getValueOrNull('CanonicalSlug') || data.url;
    const canonicalUrl = cslug !== 'index'
      ? `https://${url}/${cslug}`
      : `https://${url}`;

    return (
      <AirtableImage image={ fav } render={ faviconUrl =>
        <Helmet htmlAttributes={{ lang: 'en' }}>
          <title>{ title }</title>
          <meta name="title" content={ metaTitle } />

          { description ?
            <meta name="description" content={ description } />
          : null }

          { noIndex ?
            <meta name="robots" content="noindex" />
          : null }

          <link rel="canonical" href={ canonicalUrl } />

          { /* google adwords tracking stuff */ }

          { isProd ?
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-1022105141"></script>
          : null }

          { isProd ?
            <script>
              { `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-1022105141');
              ` }
            </script>
          : null }

          { /* google analytics tracking -- again with repeating conditionals
          since react helment does not support fragments in the component
          body */ }

          { gaTracking && isProd ?
            <script async src={ `https://www.googletagmanager.com/gtag/js?id=${gaTracking}` }></script>
          : null }
          { gaTracking && isProd ?
            <script>
              { `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', '${gaTracking}');
              ` }
            </script>
          : null }

          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />

          <meta property="og:title" content={ metaTitle }/>
          <meta property="og:site_name" content={ company } />

          { facebook ?
            <meta property="article:publisher" content={ facebook } />
          : null }

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={ metaTitle }/>

          {/* react helment doesnt support fragment, so the below repitishe is
          necesssary */}

          { twitterHandle ?
              <meta name="twitter:site" content={ twitterHandle }/>
          : null }

          { twitterHandle ?
              <meta name="twitter:creator" content={ twitterHandle }/>
          : null }

          <link rel="shortcut icon" href={ faviconUrl }></link>
        </Helmet>
      } />
    );
  }

}